import { Button, H2 } from "@sellar-io/components";
import { ReactElement } from "react";
import { useIntercom } from "react-use-intercom";
import { useShallow } from "zustand/react/shallow";

import {
  BuyerCreationFlowStep,
  useBuyerCreationFlowStore,
} from "./BuyerCreationFlowStore";

export function BuyerSignupClaimMismatch(): ReactElement {
  const intercom = useIntercom();
  const { buyerDetails, setBuyerDetails, setStep } = useBuyerCreationFlowStore(
    useShallow((state) => ({
      buyerDetails: state.buyerDetails,
      setBuyerDetails: state.setBuyerDetails,
      setStep: state.setStep,
    })),
  );
  return (
    <div className={"m-auto flex flex-col justify-center gap-4"}>
      <div className={"flex flex-col gap-2"}>
        <H2 className={"text-center"}>Unable to join venue</H2>
        <p className={"text-center"}>
          We are unable to add you to{" "}
          <strong>{buyerDetails?.Business.name}</strong>. If you believe you
          should be added to this business account, please contact the team
          powering our trade platform, Sellar, to request access.
        </p>
      </div>
      <div className="grid gap-2 md:grid-cols-2">
        <Button
          className={"col-span-2 w-full md:col-span-1"}
          onClick={() => {
            setStep(BuyerCreationFlowStep.BuyerBusinessMatchStep);
            setBuyerDetails(undefined);
          }}
          color={"secondary"}
        >
          Go back
        </Button>
        <Button
          className={"col-span-2 w-full md:col-span-1"}
          onClick={() => intercom.show()}
        >
          Get in touch
        </Button>
      </div>
    </div>
  );
}
